//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action } from './flowTypes'

const initialState:ReducerState$Type = {
    openAddInvItem: false,
    invoiceItemSelectedIndex: null,
    lastInvoiceItemSelectedIndex: null,
    vendors: [],
    vendorsLoaded: false,
    storeLocations: [],
    storeLocationsLoaded: false,
    error: '',
    invoiceSubmitted: false,
    demeterHeader: null,
    demeterItems: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'item_row_index',
    sortOrder: 'asc',
    demeterItemId: null,
    anyChanges: false,
    totalSumOfItemAmount: 0,
    demeterItem: null,
    demeterItemId: null,
    formData: {},
    reviewQuestions: [],
    formError: {}
}

//Open Add New Item Screen : actionTypes.OPEN_ADD_INV_ITEM_FORM
const openAddNewInvItem = (state:ReducerState$Type) => {
    return {
        ...state,
        openAddInvItem: true,
        demeterItem: null
    }
}
//Close Add New Item Screen : actionTypes.CANCEL_ADD_INV_ITEM_FORM
const cancelAddNewInvItem = (state:ReducerState$Type)=>{
    return {
        ...state,
        openAddInvItem: false
    }
}
//In use : actionTypes.DEMETER_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: '',
        demeterItems: []
    }
}
//In use : actionTypes.DELETE_DEMETER_ITEM_ERROR
const invoiceSubmittedError = (state:ReducerState$Type,action:Action) => {
    return {
        ...state,
        error: action.error
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

//In use : actionTypes.REFRESH_DEMETER_VENDORS_SUCCESS
const refreshedDemeterVendors = (state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        vendors: action.vendors,
        vendorsLoaded: true
    }
}
//In use : actionTypes.REFRESH_DEMETER_VENDORS_ERROR
const refreshedDemeterVendorsError = (state:ReducerState$Type,action:Action)=> {
    return {
        ...state,
        error: action.error
    }
}
//In use : actionTypes.REFRESH_DEMETER_STORE_LOCATIONS_SUCCESS
const refreshedDemeterStoreLocations = (state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        storeLocations: action.storeLocations,
        storeLocationsLoaded: true
    }
}
//In use : actionTypes.REFRESH_DEMETER_STORE_LOCATIONS_ERROR
const refreshedDemeterStoreLocationsError = (state:ReducerState$Type,action:Action)=> {
    return {
        ...state,
        error: action.error
    }
}
//In use : actionTypes.GET_DEMETER_ITEMS_SUCCESS
const receivedDemeterItems=(state:ReducerState$Type,action:Action)=>{
    const { demeterItems,count,page,pageSize,pages,sortField,sortOrder,demeterHeaderId,taskAcceptedInfoId,totalSumOfItemAmount } = (action.data:any);
    return {
        ...state,
        demeterItems: demeterItems,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        anyChanges: false,
        demeterHeaderId: demeterHeaderId,
        taskAcceptedInfoId: taskAcceptedInfoId,
        totalSumOfItemAmount: totalSumOfItemAmount,
        error: ''
    }
}
//In use : actionTypes.GET_DEMETER_ITEMS_ERROR
const receivedDemeterItemsError=(state:ReducerState$Type, action:Action)=> {
    return {
        ...state,
        error: action.error
    }
}
//In use : actionTypes.CREATE_NEW_DEMETER_ITEM_SUCCESS
const newDemeterItemCreated=(state:ReducerState$Type)=>{
    return {
        ...state,
        anyChanges: true,
        openAddInvItem: false
    }
}
//In use : actionTypes.CREATE_NEW_DEMETER_ITEM_ERROR
const newDemeterItemCreateError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}
//In use : actionTypes.EDIT_DEMETER_ITEM
const editDemeterItem=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        openAddInvItem: true,
        demeterItem: action.demeterItem
    }
}
//In use : actionTypes.UPDATE_DEMETER_ITEM_SUCCESS
const updatedDemeterItem=(state:ReducerState$Type)=>{
    return {
        ...state,
        openAddInvItem: false,
        demeterItem: null
    }
}
//In use : actionTypes.UPDATE_DEMETER_ITEM_ERROR
const updateDemeterItemError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}
//In use : actionTypes.MOVE_DOWN_DEMETER_ITEM_SUCCESS
const moveDownDemeterItemSuccess=(state:ReducerState$Type)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}
//In use : actionTypes.MOVE_DOWN_DEMETER_ITEM_ERROR
const moveDownDemeterItemError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}
//In use : actionTypes.MOVE_UP_DEMETER_ITEM_SUCCESS
const moveUpDemeterItemSuccess=(state:ReducerState$Type)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}
//In use : actionTypes.MOVE_UP_DEMETER_ITEM_ERROR
const moveUpDemeterItemError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}
//In use : actionTypes.DELETE_DEMETER_ITEM_SUCCESS
const deletedDemeterItemSuccess=(state:ReducerState$Type)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}
//In use : actionTypes.DELETE_DEMETER_ITEM_ERROR
const deletedDemeterItemError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}
//In use : actionTypes.SELECTED_DEMETER_ITEM_ID
const selectedDemeterItemId=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        demeterItemId: action.id
    }
}

const refreshedDemeterItem=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        demeterItem: action.demeterItem
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const editVerifyFormDataError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        error: action.error
    }
}

const updateFormError=(state:ReducerState$Type,action:Action)=>{
    return {
        ...state,
        formError: action.formError
    }
}

export default reduce(initialState,{
    [actionTypes.DEMETER_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.OPEN_ADD_INV_ITEM_FORM]: openAddNewInvItem,
    [actionTypes.CANCEL_ADD_INV_ITEM_FORM]: cancelAddNewInvItem,
    [actionTypes.REFRESH_DEMETER_VENDORS_SUCCESS]: refreshedDemeterVendors,
    [actionTypes.REFRESH_DEMETER_VENDORS_ERROR]: refreshedDemeterVendorsError,
    [actionTypes.REFRESH_DEMETER_STORE_LOCATIONS_SUCCESS]: refreshedDemeterStoreLocations,
    [actionTypes.REFRESH_DEMETER_STORE_LOCATIONS_ERROR]: refreshedDemeterStoreLocationsError,
    [actionTypes.GET_DEMETER_ITEMS_SUCCESS]: receivedDemeterItems,
    [actionTypes.GET_DEMETER_ITEMS_ERROR]: receivedDemeterItemsError,
    [actionTypes.CREATE_NEW_DEMETER_ITEM_SUCCESS]: newDemeterItemCreated,
    [actionTypes.CREATE_NEW_DEMETER_ITEM_ERROR]: newDemeterItemCreateError,
    [actionTypes.EDIT_DEMETER_ITEM]: editDemeterItem,
    [actionTypes.UPDATE_DEMETER_ITEM_SUCCESS]: updatedDemeterItem,
    [actionTypes.UPDATE_DEMETER_ITEM_ERROR]: updateDemeterItemError,
    [actionTypes.MOVE_DOWN_DEMETER_ITEM_SUCCESS]: moveDownDemeterItemSuccess,
    [actionTypes.MOVE_DOWN_DEMETER_ITEM_ERROR]: moveDownDemeterItemError,
    [actionTypes.MOVE_UP_DEMETER_ITEM_SUCCESS]: moveUpDemeterItemSuccess,
    [actionTypes.MOVE_UP_DEMETER_ITEM_ERROR]: moveUpDemeterItemError,
    [actionTypes.DELETE_DEMETER_ITEM_SUCCESS]: deletedDemeterItemSuccess,
    [actionTypes.DELETE_DEMETER_ITEM_ERROR]: deletedDemeterItemError,
    [actionTypes.SELECTED_DEMETER_ITEM_ID]: selectedDemeterItemId,
    [actionTypes.REFRESH_DEMETER_ITEM]: refreshedDemeterItem,
    [actionTypes.DEMETER_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.DEMETER_INV_SUBMIT_ERROR]: invoiceSubmittedError,
    [actionTypes.DEMETER_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.DEMETER_EDIT_VERIFY_FORM_DATA_ERROR]: editVerifyFormDataError,
    [actionTypes.DEMETER_UPDATE_FORM_ERROR]: updateFormError
});


// WEBPACK FOOTER //
// ./src/redux/demeter/reducer.js